import styled from 'styled-components';

export const CategoryGridContainer = styled.div`
  display: block;
  align-items: center;
  flex-direction: column;
  padding: 0 0 30px 0;
  margin-bottom: 30px;
  background-color: ${(props) =>
    props.sectionBgColor && props.showNewProductVideoCardUx
      ? props.sectionBgColor
      : ''};
`;

export const VideoCardWrapper = styled.div`
  position: relative;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.09);
  margin: 4px 0;

  @media (min-width: 720px) {
    width: 100%;
    min-width: 300px;
  }

  @media (max-width: 720px) {
    flex-basis: 50%;
    flex-shrink: 0;
    margin: 4px;
    min-width: 200px;
  }
`;

export const VideoContainer = styled.div`
  flex-basis: 44%;
  margin: 4px;
  border-radius: 8px;

  .video-player {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: inherit;
  }
`;
export const NewUxVideo = styled.div`
  width: 100%;
  height: 100%;
  margin: 0 auto;
  border-radius: 8px;
  background: white;
  display: flex;
  flex-direction: column;
  align-items: center;

  .video-element {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .caption-wrapper {
    position: absolute;
    bottom: 0;
    left: 0;
    z-index: 2;
    width: 100%;
  }
  .video-player {
    width: 100%;
    height: auto;
    object-fit: cover;
    border-radius: inherit;
  }

  .fade-overlay {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 80px;
    background: linear-gradient(
      to bottom,
      rgba(255, 255, 255, 0) 0%,
      white 100%
    );
    pointer-events: none;
    z-index: 2;
  }

  .white-caption-block {
    width: 100%;
    background: white;
    position: relative;
    top: 0;
    z-index: 1;
    padding: 12px 16px 16px;
    // box-shadow: 0 -6px 20px rgba(255, 255, 255, 0.9);
    margin-top: -12px;
    border-radius: 0 0 12px 12px;
  }

  .Video-title {
    width: 100%;
    margin: 0;
    font-size: 14px;
    font-weight: bold;
    color: #000;
  }

  .Video-description {
    width: 100%;
    margin: 4px 0 0 0;
    font-size: 13px;
    opacity: 0.54;
    font-weight: 300;
    color: #000;
  }
`;

export const DotsWrapper = styled.div`
  display: flex;
  justify-content: center;
  gap: 4px;
  padding: 8px 0;
  margin-top: 8px;
  overflow: hidden;

  @media (max-width: 768px) {
    padding: 6px 0;
    gap: 3px;
    margin-top: 6px;
  }
`;

export const VideoWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  border-radius: 8px;

  video {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }

  .fade-overlay {
    position: absolute;
    bottom: 0;
    left: 0;
    height: 160px;
    width: 100%;
    background: linear-gradient(
      to bottom,
      rgba(255, 255, 255, 0) 0%,
      white 100%
    );
    z-index: 1;
    pointer-events: none;
  }
`;

export const Caption = styled.div`
  ${(props) =>
    props.showNewProductVideoCardUx &&
    `
    position: relative;
    padding: 20px 16px 16px;
    background: white;
    text-align: center;
    font-size: 18px;
    color: #333;

    &::before {
      content: "";
      position: absolute;
      top: -20px;
      left: 0;
      width: 100%;
      height: 40px;
      background: linear-gradient(to bottom, transparent, white);
      pointer-events: none;
    }
  `}
`;

export const ProductGrid = styled.div`
  padding-top: 18px;
  width: 70%;
  display: grid;
  -webkit-box-pack: start;
  justify-content: flex-start;
  grid-template-columns: repeat(5, 1fr);
  margin: 0 auto;
  gap: 20px;

  @media (max-width: 720px) {
    grid-template-columns: repeat(2, 1fr);
    width: 100%;
    padding: 8px;
    gap: 4px;
  }
  .variantType {
    margin-top: 10px;
    padding: 3px 8px;
    border-radius: 7px;
    background-color: #ebebeb;
    width: max-content;
    p {
      font-size: clamp(9px, 2vw, 14px);
      color: rgba(0, 0, 0, 0.6);
      font-weight: 500;
    }
  }
`;

export const ProductCarousel = styled.div`
  padding-top: 18px;
  width: 70%;
  display: flex;
  margin: 0 auto;
  gap: 20px;
  overflow-x: scroll;
  ::-webkit-scrollbar {
    display: none;
  }
  background-color: ${(props) =>
    props.backgroundColor ? props.sectionBgColor : ''};

  @media (min-width: 720px) {
    width: ${(props) => (props.increasedWidth ? '98%' : '')};
    width: ${(props) => (props.fromCategoryPage ? '80%' : '')};
  }

  @media (max-width: 720px) {
    grid-template-columns: repeat(2, 1fr);
    width: 100vw;
    padding: 8px;
    gap: 4px;
  }
  .variantType {
    margin-top: 10px;
    padding: 3px 8px;
    border-radius: 7px;
    background-color: #ebebeb;
    width: max-content;
    p {
      font-size: clamp(9px, 2vw, 14px);
      color: rgba(0, 0, 0, 0.6);
      font-weight: 500;
    }
  }
`;

export const BestsellerContainer = styled.div`
  padding-top: 50px;
  display: flex;
  align-items: center;
  flex-direction: column;
  @media (max-width: 720px) {
    padding-top: 0px;
    padding-bottom: 0px;
  }

  .bestseller {
    font-size: clamp(22px, 2vw, 42px);
    font-weight: 600;
    color: #675b5a;
  }
  .adore {
    font-size: clamp(22px, 2vw, 42px);
    font-weight: 600;
    text-align: left;
    color: #7e5c5c;
  }
  .elementContainer {
    padding-top: 5px;
    gap: 40px;
    cursor: pointer;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    ::-webkit-scrollbar {
      display: none;
    }

    @media (max-width: 720px) {
      gap: 12px;
      padding-top: 25px;
      cursor: none;
      overflow-x: scroll;
      scroll-behavior: smooth;
      -webkit-box-pack: start;
      justify-content: flex-start;
      width: 100%;
      padding: 0 12px;
      padding-bottom: 10px;
      position: ${(props) =>
        props.isForJoyfulPage && !props.showNewProductVideoCardUx
          ? 'sticky'
          : ''};
      top: ${(props) =>
        props.isForJoyfulPage && !props.showNewProductVideoCardUx
          ? '60px'
          : '10px'};
      background-color: white;
      z-index: ${(props) =>
        props.isForJoyfulPage && !props.showNewProductVideoCardUx ? '3' : '1'};
    }
    .tabContainer {
      padding: 16px 40px;
      background-color: #fff;
      color: rgba(0, 0, 0, 0.65);
      font-weight: 500;
      height: 100%;
      text-align: center;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-evenly;
      p {
        height: 36px;
        margin-top: 12px;
      }
      @media (min-width: 720px) {
        p {
          font-size: 20px;
          height: 20px;
        }
      }

      @media (max-width: 720px) {
        padding: 8px 2px;
        font-size: 14px;
      }
    }

    .selected {
      font-weight: 600;
      color: #ef4e5e;
      border-bottom: 4px solid #ef4e5e;
    }
  }

  .viewAllButton {
    border-radius: 10px;
    background-color: ${(props) =>
      props.isForJoyfulPage && !props.showNewProductVideoCardUx
        ? 'white'
        : '#ef4e5e'};
    width: 35%;
    margin: 0 auto;
    padding: 16px;
    margin-top: 34px;
    cursor: pointer;
    border: ${(props) =>
      props.isForJoyfulPage && !props.showNewProductVideoCardUx
        ? '2px solid #ef4e5e'
        : ''};
    p {
      font-size: clamp(16px, 2vw, 22px);
      font-weight: 600;
      text-align: center;
      color: ${(props) =>
        props.isForJoyfulPage && !props.showNewProductVideoCardUx
          ? '#ef4e5e'
          : 'rgba(255, 255, 255)'};
    }
    @media (max-width: 720px) {
      width: 93%;
      padding: 12px;
      margin-top: 5px;
      cursor: inherit;
    }
  }
`;

export const SectionHeading = styled.div`
  position: relative;
  margin-top: 20px;
  aspect-ratio: ${(props) => (props.fitHeadingImage ? '' : '336/114')};
  text-align: ${(props) => (props.fitHeadingImage ? 'center' : '')};
  padding: ${(props) => (props.fitHeadingImage ? '' : '12px')};
`;
export const ViewAllRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 8px 0;
  gap: 8px;

  @media (min-width: 768px) {
    max-width: 1200px;
    margin: 0 auto;
    padding: 12px 12px 0; // smaller horizontal padding
  }

  .viewAllInnerWrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%; // full width
    padding: 0 6px; // small gap from screen edges

    @media (max-width: 768px) {
      padding: 0 4px; // even tighter on mobile
    }
  }

  .dotsWrapper {
    display: flex;
    align-items: center;
    padding-left: 0; // no extra gap
  }
`;

export const ViewAllText = styled.p`
  height: 18px;
  font-size: 14px;
  font-weight: 500;
  line-height: normal;
  color: #ef4e5e;
  display: inline-flex;
  align-items: center;
  width: auto;
  margin: 0 0 0 auto;
  white-space: nowrap;
`;
